var r=function(r){return r.All="all",r.Transform="transform",r.Width="width",r}({});export{r as TransitionProperties};
